var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"popper-wrapper"},[_vm._t("default"),(!_vm.targetId)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShown),expression:"isShown"}],ref:"popover",staticClass:"popper",attrs:{"role":"tooltip"}},[_vm._t("popover"),_c('span',{staticClass:"popper__arrow",attrs:{"data-popper-arrow":""}})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }